define('TescoMobile_Eecc/js/savecontract-ajax',['jquery', './action/save-form', 'mage/validation'], function ($, saveFormAction) {
  return function (config, element) {
    const $element = $(element);
    if (!($element !== null && $element !== void 0 && $element.length)) {
      return;
    }
    $element.on('submit', function (event) {
      event.preventDefault();
      if (!$element.validation('isValid')) {
        return;
      }
      saveFormAction(element).done(function () {
        $element.trigger('reset');
        $element.next().addClass(config === null || config === void 0 ? void 0 : config.successMsgClass).text(config === null || config === void 0 ? void 0 : config.successMsgText);
      }).fail(function () {
        $element.next().addClass(config === null || config === void 0 ? void 0 : config.failMsgClass).text(config === null || config === void 0 ? void 0 : config.successMsgText);
      });
    });
  };
});

